import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const PageHeader = ({ title, backgroundImage, breadcrumb }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false); //2depth 드롭다운
    const dropdownRef = useRef(null);

    const handleDropdownToggle = () => {
        setIsDropdownOpen((prev) => !prev); //이전 상태값 기준으로 토글
    };

    const handleClickOutside = (event) => { //외부 클릭시 드롭다운 닫힘힘
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsDropdownOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="content-header" style={{ backgroundImage: `url(${backgroundImage})` }}>
            <h1 className="title">{title}</h1>
            <div className="container">
                <ul className="breadcrumb">
                    {breadcrumb.map((item, index) => (
                        <li key={index} className="breadcrumb-item">
                            {index === 0 ? (
                                // 홈 
                                <Link to={item.path || "/main"} className="btn home">
                                    <span className="blind">{item.label}</span>
                                </Link>
                            ) : item.dropdown ? (
                                // 드롭다운 메뉴
                                <div className="dropdown" ref={dropdownRef}>
                                    <button onClick={handleDropdownToggle} className="btn path">{item.label}</button>
                                        
                                    {isDropdownOpen && (
                                        <ul className="dropdown-menu">
                                            {item.dropdown.map((dropdownItem, idx) => (
                                                <li
                                                    key={idx}
                                                    onClick={() => {
                                                        setIsDropdownOpen(false); // 메뉴 선택 시 닫기
                                                        dropdownItem.onClick();
                                                    }}
                                                >
                                                    {dropdownItem.label}
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            ) : (
                            // 일반 텍스트
                            <span>{item.label}</span>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default PageHeader;
